<mat-card class="project-card">
  <mat-card-title class="project-title">
    <a [href]="project.url">
      <i class="fa fa-solid fa-link"></i>
    </a>
    {{project.title}}
  </mat-card-title>
  <mat-card-content class="project-summary">{{project.description}}</mat-card-content>
  <img class="project-feature-image" mat-card-image [src]="project.featureImage" alt="Tiny Tanks Warfare">
</mat-card>